import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import SearchIcon from "@material-ui/icons/Search";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import ReactDragList from "react-drag-list";
import { Row, Col } from "reactstrap";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import ConfirmModal from "../../../../../../components/ConfirmModal/ConfirmModal";
import AddIcon from "@material-ui/icons/Add";
import SaveIcon from "@material-ui/icons/Save";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import HistoryIcon from "@material-ui/icons/History";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { Tooltip, Typography, Button } from "@material-ui/core";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import PopEditorClassic from "../../../../../../components/TinyMCE/PopEditorClassic";
import SortIcon from "@material-ui/icons/Sort";
import CardContent from "@material-ui/core/CardContent";
import ClearIcon from "@material-ui/icons/Clear";
import "./AgendaStyle.css";
import EventNoteIcon from "@material-ui/icons/EventNote";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    backgroundColor: "#3a3b3c",
    borderRadius: 5,
    marginRight: theme.spacing(2),
    marginLeft: 10,
    marginRight: 10,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginLeft: 10,
      marginRight: 10,
      width: "100%",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    color: "#FFFFFF99",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#FFFFFF99",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  online: {
    background: "#44b700",
  },
  offline: {
    background: "orangered",
  },
}));

export default function AgendaList(props) {
  const [filter, setFilter] = React.useState("");
  const [agendaName, setAgendaName] = React.useState("");
  const [open, toggleModal] = React.useState(false);
  const [unlocked, setUnlocked] = React.useState(false);
  const [hasChanged, setChanged] = React.useState(false);
  const [modifiedAgenda, setAgenda] = React.useState(props.agenda);
  const [deleteIndex, setDeleteIndex] = React.useState(null);
  const [targetAgenda, setTargetAgenda] = React.useState(null);
  const [unSavedWarning, setUnsaved] = React.useState(false);
  const sortAgenda = (agendaItems) => {
    if (!agendaItems || agendaItems === "" || (agendaItems && agendaItems.length === 0)) return [];
    let res = [];
    agendaItems.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    agendaItems.map((a, i) => {
      a.sortOrder = i;
    });
    return agendaItems;
  };
  function onUnlock(val, force = false) {
    if (force) {
      setUnsaved(false);
    } else if (hasChanged && val === false) {
      setUnsaved(true);
      return;
    }
    var agenda = unlocked ? sortAgenda(modifiedAgenda) : sortAgenda(props.agenda);
    setAgenda(agenda);
    setUnlocked(val);
  }
  const toggleDelete = (val, index) => {
    if (val === true && deleteIndex !== null) {
      setDeleteIndex(null);
    }
    setDeleteIndex(index);
    toggleModal(val);
  };
  const searchFilter = (e) => {
    setFilter(e.target.value);
  };
  const handleOrderChange = (event, dataSource) => {
    const sortedAgenda = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i;
      return el;
    });
    setAgenda(sortedAgenda);
    setChanged(true);
  };

  const defaultAgendaItem = (sortOrder, eventId) => {
    return {
      agendaItemId: agenda && agenda.length > 0 ? agenda.length * -1 : -1,
      sortOrder,
      name: "Agenda " + sortOrder,
      active: false,
      text: "*Text*",
      eventId,
    };
  };
  const save = () => {
    setUnsaved(false);
    const agenda = Array.from(props.agenda);
    setChanged(false);
    if (!unlocked) props.handleAgendaOnChange(agenda);
    else props.handleAgendaOnChange(modifiedAgenda);
  };
  const addAgenda = () => {
    /*    const agenda = Array.from(props.agenda); */

    props.agenda.push(defaultAgendaItem(agenda ? agenda.length + 1 : 0, props.eventId));
    /*     setAgenda(agenda) */
    /*    setChanged(true) */
    props.selectAgenda(agenda[agenda.length - 1]);
    /*     props.handleAgendaOnChange(agenda); */
  };
  function deleteAgenda() {
    if (deleteIndex === null) return;
    if (deleteIndex < 0) {
      let magenda = sortAgenda(Array.from(modifiedAgenda));
      magenda = magenda.filter((a) => a.agendaItemId !== deleteIndex);
      magenda.map((m, i) => {
        m.sortOrder = i;
      });
      setAgenda(magenda);
      setChanged(false);
    } else {
      let magenda = sortAgenda(Array.from(modifiedAgenda));
      magenda = magenda.filter((a) => a.agendaItemId !== deleteIndex);
      magenda.map((m, i) => {
        m.sortOrder = i;
      });
      setAgenda(magenda);
      props.deleteAgendaItem(deleteIndex);
    }
    setDeleteIndex(null);
    if (open) toggleModal(false);
  }
  const editAgenda = (e, index) => {
    let agenda = sortAgenda(Array.from(modifiedAgenda));
    /*     let name = e.value.replace('.', '.\n') */
    agenda[index].name = e;
    setAgenda(agenda);
    setChanged(true);
    /*     props.handleAgendaOnChange(agenda); */
  };

  const toggleVisibility = (value, index) => {
    let agenda = sortAgenda(Array.from(props.agenda));
    if (agenda[index] !== undefined) agenda[index].hidden = value;

    props.handleAgendaOnChange(agenda);
  };
  const activateAgenda = (value, index) => {
    let agenda = sortAgenda(Array.from(props.agenda));
    if (unlocked) {
      let mAgenda = Array.from(modifiedAgenda);
      if (agenda[index] !== undefined) mAgenda[index].active = value;
      setAgenda(mAgenda);
    }
    agenda.map((a) => {
      a.active = false;
    });
    if (agenda[index] !== undefined) agenda[index].active = value;

    props.handleAgendaOnChange(agenda);
    if (value === false) {
      props.deactivateSpeakers(agenda[index].agendaItemId);
    }
  };
  const formatTime = (date) => {
    if (!date) return null;
    let formattedDate = new Date(date);
    let h = formattedDate.getHours();
    let m = formattedDate.getMinutes();
    if (m < 10) m = "0" + m;
    if (h < 10) h = "0" + h;
    return h + ":" + m;
  };
  const selectAgenda = (a) => {
    if (props.selectedAgenda && props.selectedAgenda.agendaItemId < 0 && props.selectedAgenda.agendaItemId != a.agendaItemId) {
      setUnsaved(true);
      setTargetAgenda(a);
    } else {
      props.selectAgenda(a);
    }
  };
  const handleWarning = (s = false) => {
    if (!s && targetAgenda && targetAgenda.agendaItemId != props.selectedAgenda.agendaItemId) {
      props.selectAgenda(targetAgenda);
      props.handleAgendaOnChange(
        props.agenda.filter((a) => a.agendaItemId !== selectedAgenda.agendaItemId),
        true
      );
      setTargetAgenda(null);
    } else {
      props.selectAgenda(targetAgenda);
      save();
      setTargetAgenda(null);
    }
    setUnsaved(false);
  };
  const classes = useStyles();
  const { agenda, speakers, showSpeakers, selectedAgenda } = props;
  const agendaItems = unlocked ? sortAgenda(modifiedAgenda) : sortAgenda(props.agenda);
  return (
    <div style={{ marginTop: 10, overflowX: "hidden" }}>
      <div style={{ width: "100%", display: "inline-flex" }}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            onInput={searchFilter}
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
        {!unlocked ? (
          <IconButton disabled={agendaItems.find((a) => a.agendaItemId < 0)} onClick={() => addAgenda()} edge="start" style={{ padding: "0px 10px", color: "#ffffff99" }}>
            <AddIcon />
          </IconButton>
        ) : null}
        <IconButton onClick={() => onUnlock(!unlocked)} edge="start" style={{ padding: "0px 10px", color: "#ffffff99" }}>
          <SortIcon />
        </IconButton>
        {unlocked ? (
          <IconButton
            onClick={save}
            disabled={!hasChanged}
            edge="start"
            style={{
              padding: "0px 10px",
              color: !hasChanged ? "rgba(255, 255, 255, 0.28)" : "#ffffff99",
            }}
          >
            <SaveIcon />
          </IconButton>
        ) : null}
      </div>
      <List className="dark-list" dense={true} style={{ maxHeight: "calc(96vh - 191px)", overflowY: "auto", paddingRight: 15 }}>
        {!unlocked
          ? agendaItems
            .filter((ia) => ia.name.toLowerCase().includes(filter.toLowerCase()) && ia.name !== "JX_REMOVE" /* && ia.agendaItemId > 0 */)
            .map((a, index) => {
              return (
                <Card
                  key={index}
                  className="dark-card"
                  style={{
                    margin: "5px 0px",
                    boxShadow: "none",
                    marginLeft: "10px",
                    border: a.active ? "3px solid #20a8d8e0" : undefined,
                  }}
                >
                  <ListItem
                    onClick={() => selectAgenda(a)}
                    style={{
                      margin: 0,
                      padding: 5,
                      background: a.active ? "rgb(32 168 216 / 27%)" : selectedAgenda && selectedAgenda.agendaItemId === a.agendaItemId ? "#2f2f2f" : undefined,
                    }}
                  >
                    <ListItemAvatar style={{ position: "relative" }} className="">
                      <Avatar
                        style={{
                          opacity: a.closedDateTime ? 0.65 : 1,
                          backgroundColor: a.active ? "rgb(57 167 201)" : "rgb(107 79 142)",
                        }}
                      >
                        {a.active ? <EventAvailableIcon /> : <EventNoteIcon />}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      /*       secondary={
                        a.closedDateTime ? (
                          <div className="passed-badge">
                            <SystemLabel name="Passed" />
                          </div>
                        ) : null
                      } */
                      style={{ /* maxWidth: '65%', */ color: "#fff", opacity: a.closedDateTime ? 0.65 : 1 }}
                      primary={a ? a.name : "NoLabel"}
                    />
                    {props.allowSpeaker === true ? (
                      <Tooltip title={<SystemLabel name="OpenSpeakerListTooltip" />}>
                        <IconButton className="icon-button-dark-s" style={{ color: "#ffffff99" }} onClick={() => showSpeakers(a.agendaItemId)}>
                          <RecordVoiceOverIcon />{" "}

                          <Typography className="primary-text" style={{ marginLeft: "10px", fontSize: "1.2rem" }}>
                            {speakers ? speakers.filter((s) => s.agendaItemId === a.agendaItemId && s.closedDateTime == null).length : 0}
                          </Typography>

                        </IconButton>
                      </Tooltip>
                    ) : null}
                    <Tooltip title={<SystemLabel name="ActivateAgendaTooltip" />}>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          activateAgenda(!a.active, index);
                        }}
                        style={{
                          padding: "3px",
                          cursor: "pointer",
                          color: a.active ? "#ffff" : "#ffffffde",
                          background: a.active ? "#20a8d8e0" : undefined,
                        }}
                      >
                        <PlayArrowIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title={a.hidden ? <SystemLabel name="UnhideAgendaTooltip" /> : <SystemLabel name="HideAgendaTooltip" />}>
                      <IconButton
                        onClick={() => {
                          toggleVisibility(!a.hidden, index);
                        }}
                        style={{
                          padding: "3px",
                          cursor: "pointer",
                          color: !a.hidden ? "#ffff" : "#ffffffde",
                        }}
                      >
                        {a.hidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                      </IconButton>
                    </Tooltip>
                  </ListItem>
                </Card>
              );
            })
          : null}

        {unlocked ? (
          <DragList
            activateAgenda={activateAgenda}
            modifiedAgenda={modifiedAgenda}
            speakers={speakers}
            activeAgenda={agenda ? agenda.find((a) => a.active === true) : null}
            editAgenda={editAgenda}
            toggleDelete={toggleDelete}
            filter={filter}
            handleOrderChange={handleOrderChange}
            formatTime={formatTime}
            showSpeakers={showSpeakers}
          />
        ) : null}
      </List>
      <ConfirmModal onAction={() => deleteAgenda()} onCancel={() => toggleModal(!open)} header={"AreYouSure"} open={open} text={"DoWantToDeleteAgenda"} />
      <ConfirmModal onAction={() => handleWarning(true)} onCancel={() => handleWarning(false)} header={"UnsavedChanges"} open={unSavedWarning} text={"DoYouWannaSave"} />
    </div>
  );
}

function DragList({ activateAgenda, modifiedAgenda, filter, handleOrderChange, formatTime, showSpeakers, speakers, editAgenda, toggleDelete, activeAgenda }) {
  const onEdit = (e, index) => {
    editAgenda(e, index);
  };
  return (
    <div>
      <ReactDragList
        animation={10}
        dataSource={modifiedAgenda.filter((ia) => ia.name.toLowerCase().includes(filter.toLowerCase()) && ia.name !== "JX_REMOVE")}
        rowKey={"agendaItemId"}
        className="simple-drag"
        rowClassName="simple-drag-row"
        dragClass="agenda-drag"
        handles={true}
        onUpdate={(event, dataSource) => handleOrderChange(event, dataSource)}
        row={(a, index) => {
          return (
            <Card className="dark-card" style={{ padding: "0px", margin: "5px 0px", width: "100%" }}>
              <ListItem>
                {/*   <IconButton className="icon-button-dark-s agenda-drag" style={{ cursor: 'move', color: '#ffffff99' }}>
                            <DragIndicatorIcon />
                        </IconButton> */}
                <div
                  className="dark-list"
                  style={{
                    color: "#FFFFFF99",
                    backgroundColor: "#3a3b3c",
                    border: "0px",
                    width: "100%",
                    maxHeight: "120px",
                    overflowY: "auto",
                    padding: "10px",
                  }}
                >
                  {a.name}
                </div>

                <IconButton className="icon-button-dark-s" style={{ opacity: 0.8 }} onClick={() => null}>
                  <Tooltip
                    title={
                      a.closedDateTime ? (
                        <Typography variant="span">
                          {
                            <React.Fragment>
                              <SystemLabel name="Closed" /> {formatTime(a.closedDateTime)}
                            </React.Fragment>
                          }
                        </Typography>
                      ) : (
                        <SystemLabel name="NotStarted" />
                      )
                    }
                  >
                    {a.closedDateTime ? <HistoryIcon /> : <ScheduleIcon />}
                  </Tooltip>
                </IconButton>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    activateAgenda(!a.active, index);
                  }}
                  style={{
                    padding: "3px",
                    cursor: "pointer",
                    color: a.active ? "#ffff" : "#ffffffde",
                    background: activeAgenda && a.agendaItemId === activeAgenda.agendaItemId ? "#20a8d8e0" : undefined,
                  }}
                >
                  <PlayArrowIcon />
                </IconButton>
                {/*      <IconButton className="icon-button-dark-s" onClick={() => toggleDelete(true, a.agendaItemId)} style={{ cursor: 'pointer', color: '#ffffff99' }}>
                            <DeleteIcon />
                        </IconButton> */}
              </ListItem>
            </Card>
          );
        }}
      />
    </div>
  );
}

function AgendaEditor({ template, text, onChange, onclose }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    onclose();
  };
  const onSave = () => { };
  const onEdit = (e) => { };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;
  return (
    <div>
      <div className="bottom-edit-wrap">
        <div className="bottom-edit-pop">
          <Card>
            <Row className="w-100 inline-flex">
              <Col className="col-6 text-left" style={{ padding: "15 40px" }}>
                {text}
              </Col>
              <Col
                className="col-6 text-right"
                style={{
                  display: "inline-flex",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton onClick={() => handleClick(null)}>
                  <ClearIcon />
                </IconButton>
              </Col>
            </Row>
            {/*     <Row>
                </Row> */}
            <CardContent style={{ border: "1px solid gainsboro" }}>
              <div
                className="styleWrapper"
                style={{
                  width: "100%",
                  border: "1px solid gainsboro",
                  padding: "10px",
                }}
              >
                {/* <style>
                                {`${toKebabCase(template.content, true)} '.tox-tinymce { opacity: 0} '`}
                            </style> */}
                <PopEditorClassic value={text} editMode={true} onChange={onEdit} slimFormat={true} path={"text"} style={undefined} />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
